import { createFileRoute } from "@tanstack/react-router";

import { AdminSubscriptionCheckoutScreen } from "@/features/admin/screens/SubscriptionCheckout";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/subscription-checkout",
)({
  loader: ({ context: { trpcQueryUtils } }) => {
    trpcQueryUtils.admin.listBillingPlanPrices.prefetch().catch(console.error);
  },
  component: AdminSubscriptionCheckoutScreen,
});
